<template>
  <div class="form-editor custom-scroll-bar-2">
    <vue-element-loading :active="isLoading" is-full-screen />
    <div class="form-editor__toolbar">
      <button class="btn-secondary cursor-pointer" @click="goBack">← Danh sách</button>
      <div class="form-editor__toolbar-actions">
        <button class="btn-secondary cursor-pointer" :disabled="saving" @click="save(false)">Lưu nháp</button>
        <button class="btn-primary cursor-pointer" :disabled="saving" @click="save(true)">Lưu & kích hoạt</button>
      </div>
    </div>

    <div class="form-editor__grid">
      <div class="form-editor__panel">
        <h3 class="heading-500 mb-10px">Cấu hình</h3>
        <label class="text-400-medium">Tiêu đề</label>
        <input v-model="definition.title" class="form-control input-custom w_100 mb-10px" />

        <label class="text-400-medium">Mô tả</label>
        <textarea v-model="definition.description" class="form-control input-custom w_100 mb-10px" rows="2" />

        <label class="text-400-medium">Bắt đầu (tuỳ chọn)</label>
        <input v-model="startsAtLocal" type="datetime-local" class="form-control input-custom w_100 mb-10px" />

        <label class="text-400-medium">Hết hạn (tuỳ chọn)</label>
        <input v-model="expiresAtLocal" type="datetime-local" class="form-control input-custom w_100 mb-10px" />

        <label class="text-400-medium">Ưu tiên</label>
        <input v-model.number="priority" type="number" class="form-control input-custom w_100 mb-15px" />

        <h4 class="text-400-semibold mb-8px">Modal</h4>
        <label class="form-editor__check">
          <input v-model="settings.allow_dismiss" type="checkbox" :disabled="settings.require_submit" />
          Cho phép "Để sau" (ẩn trong phiên hiện tại)
        </label>
        <label class="form-editor__check">
          <input v-model="settings.require_submit" type="checkbox" @change="onRequireSubmitChange" />
          Bắt buộc gửi (blocking — không dismiss)
        </label>
        <label class="form-editor__check">
          <input v-model="settings.show_until_submitted" type="checkbox" />
          Hiện lại mỗi phiên cho đến khi gửi
        </label>
        <label class="text-400-medium mt-10px">Hiển thị trên</label>
        <label class="form-editor__check"><input v-model="showWorkplace" type="checkbox" /> Bảng tin</label>
        <label class="form-editor__check"><input v-model="showMessenger" type="checkbox" /> Chat</label>

        <h4 class="text-400-semibold mt-15px mb-8px">Thêm câu hỏi</h4>
        <div class="form-editor__add-types">
          <button
            v-for="t in fieldTypes"
            :key="t.id"
            type="button"
            class="btn-chip cursor-pointer"
            @click="addField(t.id)"
          >+ {{ t.label }}</button>
        </div>
      </div>

      <div class="form-editor__panel">
        <h3 class="heading-500 mb-10px">Câu hỏi</h3>
        <div v-for="(field, index) in definition.fields" :key="field.id" class="form-editor__field-card">
          <div class="form-editor__field-head">
            <span class="text-300-default neutral_3">{{ fieldTypeLabel(field.type) }}</span>
            <div>
              <button type="button" class="btn-icon" :disabled="index === 0" @click="moveField(index, -1)">↑</button>
              <button type="button" class="btn-icon" :disabled="index === definition.fields.length - 1" @click="moveField(index, 1)">↓</button>
              <button type="button" class="btn-icon text-danger" @click="removeField(index)">×</button>
            </div>
          </div>
          <input
            v-if="field.type !== 'description'"
            v-model="field.label"
            class="form-control input-custom w_100 mb-5px"
            placeholder="Nhãn câu hỏi"
          />
          <textarea
            v-if="field.type === 'description'"
            v-model="field.content"
            class="form-control input-custom w_100 mt-5px"
            rows="3"
            placeholder="Nội dung hướng dẫn (chỉ hiển thị, người dùng không nhập)"
          />
          <p v-if="field.type === 'description'" class="form-editor__type-hint text-200-default neutral_3">
            Loại này chỉ hiển thị văn bản. Muốn ô nhập liệu, dùng <strong>Đoạn văn</strong>.
          </p>
          <label v-if="!isLayoutField(field)" class="form-editor__check">
            <input v-model="field.required" type="checkbox" /> Bắt buộc
          </label>
          <div v-if="hasOptions(field)" class="mt-8px">
            <div v-for="(opt, oi) in field.options" :key="opt.id" class="form-editor__option-row">
              <input v-model="opt.label" class="form-control input-custom" placeholder="Lựa chọn" />
              <button type="button" class="btn-icon" @click="removeOption(field, oi)">×</button>
            </div>
            <button type="button" class="btn-chip cursor-pointer mt-5px" @click="addOption(field)">+ Lựa chọn</button>
          </div>
        </div>
      </div>

      <div class="form-editor__panel form-editor__preview">
        <h3 class="heading-500 mb-10px">Preview</h3>
        <FormSchemaRenderer :definition="definition" :readonly="false" v-model="previewAnswers" />
      </div>
    </div>
  </div>
</template>

<script>
import AdminFormService from "../../../../store/services/AdminFormService";
import FormSchemaRenderer from "../../../../components/forms/FormSchemaRenderer.vue";
import {
  FORM_FIELD_TYPES,
  defaultFormSettings,
  emptyFormDefinition,
  createField,
  fieldTypeLabel,
  fromDatetimeLocalValue,
  toDatetimeLocalValue,
} from "../../../../helper/formSchema";

export default {
  name: "FormEditor",
  components: { FormSchemaRenderer },
  data() {
    return {
      isLoading: false,
      saving: false,
      formId: null,
      definition: emptyFormDefinition(),
      settings: defaultFormSettings(),
      priority: 0,
      startsAtLocal: "",
      expiresAtLocal: "",
      previewAnswers: {},
      fieldTypes: FORM_FIELD_TYPES,
    };
  },
  computed: {
    showWorkplace: {
      get() { return (this.settings.show_on_routes || []).includes("workplace"); },
      set(v) { this.toggleRoute("workplace", v); },
    },
    showMessenger: {
      get() { return (this.settings.show_on_routes || []).includes("messenger"); },
      set(v) { this.toggleRoute("messenger", v); },
    },
  },
  created() {
    const id = this.$route.params.form_id;
    if (id && id !== "create") {
      this.formId = id;
      this.loadForm();
    }
  },
  methods: {
    fieldTypeLabel(type) {
      return fieldTypeLabel(type);
    },
    goBack() {
      this.$router.push("/admin-settings/forms");
    },
    toggleRoute(route, enabled) {
      const routes = [...(this.settings.show_on_routes || [])];
      const idx = routes.indexOf(route);
      if (enabled && idx === -1) routes.push(route);
      if (!enabled && idx !== -1) routes.splice(idx, 1);
      this.settings.show_on_routes = routes.length ? routes : ["workplace", "messenger"];
    },
    onRequireSubmitChange() {
      if (this.settings.require_submit) {
        this.settings.allow_dismiss = false;
      }
    },
    isLayoutField(field) {
      return field.type === "section" || field.type === "description";
    },
    hasOptions(field) {
      return ["single_choice", "multi_choice", "dropdown"].includes(field.type);
    },
    addField(type) {
      this.definition.fields.push(createField(type));
    },
    removeField(index) {
      this.definition.fields.splice(index, 1);
    },
    moveField(index, delta) {
      const target = index + delta;
      const fields = [...this.definition.fields];
      const tmp = fields[index];
      fields[index] = fields[target];
      fields[target] = tmp;
      this.definition.fields = fields;
    },
    addOption(field) {
      if (!field.options) field.options = [];
      field.options.push({ id: "opt_" + (field.options.length + 1), label: "Lựa chọn mới" });
    },
    removeOption(field, index) {
      if (!field.options || field.options.length <= 2) return;
      field.options.splice(index, 1);
    },
    buildPayload() {
      return {
        definition: this.definition,
        settings: this.settings,
        priority: this.priority,
        starts_at: fromDatetimeLocalValue(this.startsAtLocal),
        expires_at: fromDatetimeLocalValue(this.expiresAtLocal),
      };
    },
    async loadForm() {
      this.isLoading = true;
      try {
        const res = await AdminFormService.getById(this.formId);
        if (!res || res.status === false) return;
        const data = res.data || {};
        this.definition = data.definition || emptyFormDefinition();
        this.settings = { ...defaultFormSettings(), ...(data.settings || {}) };
        this.priority = data.priority || 0;
        this.startsAtLocal = toDatetimeLocalValue(data.starts_at);
        this.expiresAtLocal = toDatetimeLocalValue(data.expires_at);
      } finally {
        this.isLoading = false;
      }
    },
    async save(activate) {
      this.saving = true;
      try {
        const payload = this.buildPayload();
        let res;
        if (this.formId) {
          res = await AdminFormService.update(this.formId, payload);
        } else {
          res = await AdminFormService.create(payload);
        }
        if (!res || res.status === false) {
          this.$notify({ type: "error", text: (res && res.message) || "Lưu thất bại" });
          return;
        }
        const saved = res.data || {};
        this.formId = saved.id;
        if (activate) {
          await AdminFormService.activate(this.formId);
        }
        this.$notify({ type: "success", text: activate ? "Đã lưu và kích hoạt" : "Đã lưu biểu mẫu" });
        if (!this.$route.params.form_id || this.$route.params.form_id === "create") {
          this.$router.replace(`/admin-settings/forms/${this.formId}/edit`);
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form-editor {
  padding: 16px;
}
.form-editor__toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.form-editor__toolbar-actions {
  display: flex;
  gap: 8px;
}
.form-editor__grid {
  display: grid;
  grid-template-columns: 280px 1fr 340px;
  gap: 16px;
  align-items: start;
}
@media (max-width: 1200px) {
  .form-editor__grid { grid-template-columns: 1fr; }
}
.form-editor__panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px;
}
.form-editor__field-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
}
.form-editor__field-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.form-editor__check {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 14px;
}
.form-editor__add-types {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.form-editor__option-row {
  display: flex;
  gap: 6px;
  margin-bottom: 6px;
}
.btn-primary, .btn-secondary, .btn-chip, .btn-icon {
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #fff;
  padding: 6px 10px;
  font-size: 13px;
}
.btn-primary {
  background: #2563eb;
  color: #fff;
  border-color: #2563eb;
}
.form-editor__type-hint {
  margin: 6px 0 0;
  font-size: 12px;
}
.text-danger { color: #dc2626; }
</style>
